//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { useNotify } from 'react-admin';
import { Typography, Box, Card, CardContent, CircularProgress } from '@mui/material';
import { GeneralSettingsForm } from './GeneralSettingsForm';
import dataProvider from '../../providers/dataProvider';

export interface PublicSettings {
  home?: {
    quote?: {
      text?: {
        de?: string;
        en?: string;
      };
      author?: string;
      image?: string;
    };
  };
}

export const GeneralSettings = () => {
  const [settings, setSettings] = useState<PublicSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const notify = useNotify();

  useEffect(() => {
    const loadSettings = async () => {
      try {
        setLoading(true);
        const data = await dataProvider.getPublicSettings();
        setSettings(data || {});
      } catch (error) {
        console.error('Error loading settings:', error);
        notify('Error loading settings', { type: 'error' });
        setSettings({});
      } finally {
        setLoading(false);
      }
    };

    loadSettings();
  }, [notify]);

  const handleSave = async (newSettings: PublicSettings) => {
    try {
      await dataProvider.updatePublicSettings(newSettings);
      setSettings(newSettings);
      notify('Settings saved successfully', { type: 'success' });
    } catch (error) {
      console.error('Error saving settings:', error);
      notify('Error saving settings', { type: 'error' });
      throw error;
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ padding: '20px' }}>
      <Typography variant="h4" sx={{ marginBottom: '20px', fontWeight: 'bold' }}>
        General Settings
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: '30px', color: 'text.secondary' }}>
        Configure settings that apply to all deployed frontends.
      </Typography>
      
      <Card>
        <CardContent>
          <GeneralSettingsForm 
            initialSettings={settings} 
            onSave={handleSave}
          />
        </CardContent>
      </Card>
    </Box>
  );
};
